<script>
import {
  pageCommanderPaiementEtAvantagesProps,
  usePageCommanderPaiementEtAvantages
} from "./mixin";

import { mapState } from "pinia";

import Container from "@/components/atoms/container";
import LazyImage from "@/components/atoms/lazy-image";
import Icon from "@/components/atoms/icon";
import Badge from "@/components/atoms/badge";
import PaymentMethodList from "@/components/organisms/payment-method-list/mobile";
import ShippingMethodOverview from "@/containers/shipping-method/shipping-method-overview";
import Popin from "@/components/molecules/popin";
import Button from "@/components/atoms/button";
import CmsFetcher from "@/containers/cms-fetcher";
import Ethylotest from "@/components/organisms/ethylotest/mobile";
import PaymentMethodCarteKdo from "@/containers/payment-method-carte-kdo";
import { useCheckoutStore } from "@/store/checkout";

import bandeauLegalVapotageMobile from "@/assets/images/bandeau-legal-vapotage-mobile.jpg";
import bandeauLegalAlcoolMobile from "@/assets/images/bandeau-legal-alcool-mobile.jpg";

export default {
  components: {
    Container,
    LazyImage,
    Icon,
    Badge,
    PaymentMethodList,
    ShippingMethodOverview,
    Popin,
    Button,
    CmsFetcher,
    Ethylotest,
    PaymentMethodCarteKdo
  },
  props: {
    ...pageCommanderPaiementEtAvantagesProps()
  },
  computed: {
    ...mapState(useCheckoutStore, ["getCurrentPaymentMethod"])
  },
  setup(props) {
    const {
      popinCommandeRecenteVisible,
      popinCgvVisible,
      carteCoraIsMalinPlus,
      messageWarning,
      magasinName,
      magasinAllowCodePromo,
      magasinAllowPaymentCarteCarrefour,
      montantTotalTtc,
      typePanier,
      isPorteurCarteCora,
      isPorteurCarteMalin,
      processPaiement,
      modePaiementHabituel,
      modesPaiement,
      isAlcool,
      tirelire,
      cgvLink,
      carteCadeau,
      isCarteCarrefourPossible,
      modePaiementSelected,
      paiement,
      setPopinCommandeRecenteVisible,
      setPopinCgvVisible,
      redirectToPaiement,
      isDataLive
    } = usePageCommanderPaiementEtAvantages(props);

    return {
      popinCommandeRecenteVisible,
      popinCgvVisible,
      carteCoraIsMalinPlus,
      messageWarning,
      magasinName,
      magasinAllowCodePromo,
      magasinAllowPaymentCarteCarrefour,
      montantTotalTtc,
      typePanier,
      isPorteurCarteCora,
      isPorteurCarteMalin,
      processPaiement,
      modePaiementHabituel,
      modesPaiement,
      isAlcool,
      tirelire,
      cgvLink,
      carteCadeau,
      isCarteCarrefourPossible,
      modePaiementSelected,
      paiement,
      setPopinCommandeRecenteVisible,
      setPopinCgvVisible,
      redirectToPaiement,
      bandeauLegalVapotageMobile,
      bandeauLegalAlcoolMobile,
      isDataLive
    };
  }
};
</script>

<template>
  <div>
    <div
      id="content"
      role="main"
    >
      <Popin
        :visible="messageWarning !== null"
        slide-up
        class="u-text-center"
        aria-label="Attention"
        @closed="messageWarning = null"
      >
        <h2 class="u-color-primary u-font-secondary u-font-24 u-mb-sm">
          Attention
        </h2>
        <p>{{ messageWarning }}</p>
      </Popin>
      <div class="c-checkout-mobile">
        <div class="u-bgcolor-white">
          <Ethylotest v-if="isAlcool" />
        </div>
        <p class="c-checkout-mobile__location u-text-center">
          <Icon
            name="location"
            size="sm"
            class="u-mr-xxs"
          />
          Magasin {{ magasinName }}
        </p>
        <Container>
          <div class="c-checkout-mobile__step">
            <h1 class="c-checkout-mobile__step-title c-checkout-mobile__step-title--current u-mb-xs u-font-24">
              <Badge
                class="c-checkout-mobile__step-badge c-checkout-mobile__step-badge--current"
                circle
              >
                1
              </Badge>
              Mode de Livraison
            </h1>
            <ShippingMethodOverview />
          </div>
        </Container>
        <div class="payment-separator-mobile" />
        <Container>
          <h1
            v-focus
            class="c-checkout-mobile__step-title c-checkout-mobile__step-title--current u-mt-md u-mb-xs u-font-24"
            tabindex="-1"
          >
            <Badge
              class="c-checkout-mobile__step-badge c-checkout-mobile__step-badge--current"
              circle
            >
              2
            </Badge>
            Paiement & avantages
          </h1>
          <template v-if="magasinAllowPaymentCarteCarrefour && isCarteCarrefourPossible && isServiceCompatibleEuroCarrefour && isDataLive">
            <PaymentMethodCarteKdo
              class="u-mt-sm"
              @avantages="(res) => messageWarning = res.meta.message_warning ?? null"
            />
            <p
              v-if="carteCadeau?.montant"
              class="u-mt-lg u-pt-sm u-font-22 u-font-700 u-mb-sm"
            >
              Il vous reste à régler : {{ formatPrix(montantTotalTtc - carteCadeau.montant) }} €
            </p>
          </template>
          <p
            v-if="!modePaiementHabituel"
            class="u-font-14 u-color-grey-1 u-mb-md u-mt-sm"
          >
            Merci de choisir la manière dont vous souhaitez régler votre
            commande
          </p>
          <PaymentMethodList
            :selected-payment-methods="getCurrentPaymentMethod"
            :payment-methods="modesPaiement"
            :mode-paiement-habituel="modePaiementHabituel"
            :payment-methods-infos="paymentMethodsInfos"
            :montant-total-ttc="montantTotalTtc"
            :magasin-allow-code-promo="magasinAllowCodePromo"
            :is-porteur-carte-cora="isPorteurCarteCora"
            :carte-cora-is-malin-plus="carteCoraIsMalinPlus"
            :is-porteur-carte-malin="isPorteurCarteMalin"
            :tirelire="tirelire"
            :type-panier="typePanier"
            @modePaiementSelected="modePaiementSelected"
            @processPaiement="paiement"
            @displayCgv="setPopinCgvVisible(true)"
          />
        </Container>
      </div>

      <div class="c-checkout-mobile__bottom">
        <Container>
          <div class="c-checkout-mobile__step u-mt-xs">
            <h1 class="c-checkout-mobile__step-title u-font-24">
              <Badge
                class="c-checkout-mobile__step-badge"
                circle
              >
                3
              </Badge>
              Confirmation
            </h1>
          </div>
          <!-- <p class="c-checkout-mobile__notice u-text-xs u-color-text-light u-font-14">
            * Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce blandit sollicitudin nisl id pharetra. Pellentesque dignissim dui et pellentesque placerat. <br>
            '1) Fusce scelerisque lorem dolor. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nam sodales quam eget
            est ornare, nec rutrum tortor fermentum. Sed pharetra elementum ligula. <br>
            (3) Pellentesque eget magna faucibus, mattis enim sit amet, rhoncus lorem. In nec erat tortor. Nullam condimentum interdum lectus egestas convallis.
          </p> -->

          <Container class="u-text-center">
            <LazyImage
              :src="bandeauLegalAlcoolMobile"
              alt="Interdiction de vente de boissons alcooliques aux mineurs de moins de 18 ans.
                La preuve de majorité de l'acheteur est exigée au moment de la vente en ligne."
              class="u-mb-md"
              width="344"
              height="234"
            />
            <LazyImage
              :src="
                bandeauLegalVapotageMobile
              "
              alt="Interdiction de vente de produits du vapotage aux mineurs de moins de 18 ans.
                La preuve de majorité de l'acheteur est exigée au moment de la vente en ligne."
              class="u-pb-md"
              width="344"
              height="234"
            />
          </Container>
        </Container>
      </div>
    </div>
    <!-- //END Main -->
    <Popin
      slide-up
      :visible="popinCommandeRecenteVisible"
      aria-label="Vous avez déjà passé commande il y a moins de 15 minutes"
      @hidden="setPopinCommandeRecenteVisible(false)"
    >
      <div class="u-text-center">
        <h2 class="u-color-primary u-mb-md">
          Vous avez déjà passé commande il y a moins de 15 minutes
        </h2>
        <p>
          Vous êtes peut-être en train de passer une commande une seconde fois.
        </p>
        <p class="u-mb-md">
          Il pourrait s'agir d'une erreur, suite à des problèmes techniques.
        </p>
        <Button
          variant="primary"
          size="md"
          radius="full"
          outline
          class="u-m-sm"
          to="/mon-compte/mes-commandes"
        >
          Annuler la commande
        </Button>
        <Button
          variant="primary"
          size="md"
          radius="full"
          class="u-m-sm"
          @click="redirectToPaiement()"
        >
          Je passe commande
        </Button>
      </div>
    </Popin>
    <Popin
      :visible="popinCgvVisible"
      aria-label="Conditions générales de vente"
      slide-up
      size="lg"
      @hidden="setPopinCgvVisible(false)"
    >
      <CmsFetcher :link="cgvLink" />
      <div class="u-flex u-flex-justify-center">
        <Button
          variant="secondary"
          size="md"
          radius="full"
          class="u-m-sm"
          @click="setPopinCgvVisible(false)"
        >
          OK
        </Button>
      </div>
    </Popin>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/container.scss";
@import "@/assets/styles/components/checkout-mobile.scss";
</style>
